import type { TRuleWithTheme } from '@/styles/theme';

export const fields: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',

    paddingTop: '1.5rem',
    paddingBottom: '2rem',
});

export const buttons: TRuleWithTheme = () => ({
    gap: '1rem',
});

// `TextInput` sets its own 1rem/500, while `SelectInput` runs on the ParagraphSmallMedium token. Both
// are shared primitives, so the name field is matched to its neighbouring pickers here rather than in
// either of them.
export const nameInput: TRuleWithTheme = ({ theme }) => ({
    '&.ant-input': theme.typography.ParagraphSmallMedium,
});
